import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@one-thd/sui-atomic-components';

export const ClearButton = ({ onClick }) => (
  <Button
    className="sui-underline sui-whitespace-nowrap sui-pt-1"
    variant="ghost"
    onClick={onClick}
    tabIndex={0}
    aria-label="Clear all filter selections"
  >
    Clear All
  </Button>
);

ClearButton.propTypes = {
  onClick: PropTypes.func.isRequired
};